export default "__VITE_ASSET__Ct90ArEY__"